import $ from 'jquery/src/jquery'
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    const nodeSelectors = {
        container: '[js-animation-slide-up="container"]',
        item: '[js-animation-slide-up="item"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        let containers = document.querySelectorAll(nodeSelectors.container)

        containers.forEach(function (container, index) {
            let tl = gsap.timeline()
            tl.to(container.querySelector(nodeSelectors.item), {y: 0, scale: 1, duration: 0.7})

            ScrollTrigger.create({
                trigger: container,
                animation: tl,
                pin: false,
                markers: false,
                start: "top 95%",
                end: "bottom 95%",
                scrub: 0,
                invalidateOnRefresh: true,
            });
        })
    }

    return Object.freeze({
        init,
    })
}